<template>
  <div class="gf_price-compare__box__plan" :class="{ 'gf_price-compare__box__plan--trial': isTableCol4 }">
    <div class="gf_price-compare__box__plan--top" :class="{ mode_monthy: !yearlyMode }" :style="(isTrialTrial2022 && yearlyMode) || (planInDevelopment && yearlyMode) ? 'margin-bottom: 26px' : ''">
      <div class="gf_price-plan__name" :class="{ 'starter-disable': planInStarter }">{{ $t(content.title) }}</div>
      <div class="gf_price-plan__price">
        <div class="gf_price-save">
          <div class="gf_price-save__number" :class="{ 'starter-disable': planInStarter }" v-if="isProfessionalPlan" v-html="`$${basePriceOfMonthly}`"></div>
          <div class="gf_price-save__number" :class="{ 'starter-disable': planInStarter }" v-else-if="planInStarter" v-html="`$${planStaterPricing}`"></div>
          <div class="gf_price-save__number" :class="{ 'starter-disable': planInStarter }" v-else v-html="`$${isTrialTrial2022 || isDevelopmentPlan ? planFreePricing : priceOfMonthly}`"></div>
          <div class="gf_price__package" v-if="!(planInTrial || planInTrial2022 || planInDevelopment)" :class="{ 'starter-disable': planInStarter }"><span>/</span>{{ $t("dataNewPlan.month") }}</div>
        </div>
      </div>
    </div>
    <Promotion v-if="!yearlyMode" :promotion="planPromotionConditions(yearlyMode, planNo).appliedPromotion" :coupon="planCouponConditions(yearlyMode, planNo).appliedCoupon" couponClass="sticky-promotion" />

    <span class="gf_price-compare__plan--year" v-if="yearlyMode && notTrialOrDevelopment" v-html="!planInStarter && !isProfessionalPlan ? $t('pricing.billedMonthYear', { discountMoYr: checkNumberFormat(priceOfMonthly * 12), discountSave: (discountTextOfYearly * 12).toFixed(0) }) : '&nbsp;'"></span>

    <div class="gf_price-compare__box__plan--action" v-if="(isCurrentPlan && planInTrialExpire) || (isCurrentPlan && planInTrial) || (isCurrentPlan && planInStarter) || planInTrial || planInTrial2022 || planInDevelopment || isDevelopmentPlan">
      <a @click="() => {}" class="gf_plan-item__section--choose">
        <div class="gf_price__button gf_price__trial__expire">
          <span class="gf_pe-none" v-html="currentPlanTextButton"></span>
        </div>
      </a>
    </div>

    <div class="gf_price-compare__box__plan--action" v-else-if="isBFCM && !yearlyMode">
      <a class="gf_plan-item__section--choose">
        <div class="gf_price__button gf_price__recommend" :data-plan="planNo" :data-url="chargePlan(planNo, yearlyMode)" :yearly-mode="yearlyMode" action="upgrade" @click="onChangePlan">
          <span class="gf_pe-none" v-html="$t('dataNewPlan.upgradePlan.monthly')"></span>
        </div>
      </a>
    </div>

    <div class="gf_price-compare__box__plan--action" v-else-if="isDevelopmentStore && !planInDevelopment">
      <a @click="() => {}" class="gf_plan-item__section--choose">
        <div class="gf_price__button gf_price__trial__expire" v-html="prePlanTextButton"></div>
      </a>
    </div>

    <div class="gf_price-compare__box__plan--action" v-else-if="isProfessionalPlan">
      <a @click="() => {}" class="gf_plan-item__section--choose">
        <div class="gf_price__button gf_price__trial__expire">
          <i class="icon icon-check-new" v-if="!trialExpire"></i>
          <span class="gf_pe-none" v-html="currentPlanTextButton"></span>
        </div>
      </a>
    </div>

    <div class="gf_price-compare__box__plan--action" v-else-if="isCurrentPlan">
      <a class="gf_plan-item__section--choose">
        <div :data-url="chargeCurrentPlan" @click="onChangePlan" :yearly-mode="yearlyMode" :action="chargePlanActionAttribute" class="gf_price__button gf_price__current" :class="{ gf_price__current__switch_plan: (yearlyMode && notAnnually) || (!yearlyMode && !notAnnually), gf_price__upgrade: yearlyMode && notAnnually }">
          <i class="icon icon-check-new" v-if="!((yearlyMode && notAnnually) || (!yearlyMode && !notAnnually))"></i>
          <span class="gf_pe-none" v-html="currentPlanTextButton"></span>
        </div>
      </a>
    </div>

    <div class="gf_price-compare__box__plan--action" v-else-if="isRecommended">
      <a class="gf_plan-item__section--choose">
        <div class="gf_price__button gf_price__recommend" :data-plan="planNo" :data-url="chargePlan(planNo, yearlyMode)" :yearly-mode="yearlyMode" action="upgrade" @click="onChangePlan">
          <span class="gf_pe-none" v-html="yearlyMode ? $t('dataNewPlan.upgradePlan', { planMode: txtPlanMode }) : $t('dataNewPlan.upgradePlan.monthly')"></span>
        </div>
      </a>
    </div>

    <div class="gf_price-compare__box__plan--action" v-else>
      <div v-if="isDowngrade" class="gf_plan-item__section--choose">
        <router-link replace :to="{ name: 'Downgrade', params: { plan: planNo, yearlyMode: yearlyMode } }">
          <div class="gf_price__button gf_price__upgrade" :data-plan="planNo" :yearly-mode="yearlyMode" :action="chargePlanActionAttribute" @click="onChangePlan">
            <span class="gf_pe-none" v-html="prePlanTextButton"></span>
          </div>
        </router-link>
      </div>
      <a v-else class="gf_plan-item__section--choose">
        <div class="gf_price__button gf_price__upgrade" :data-plan="planNo" :action="chargePlanActionAttribute" :yearly-mode="yearlyMode" :data-url="chargePlan(planNo, yearlyMode)" @click="onChangePlan">
          <span class="gf_pe-none" v-html="prePlanTextButton"></span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import plan from "@/modules/Pricing/mixins/plan";
import promotion from "@/modules/Pricing/mixins/promotion";
import { PLAN_NO, PLAN_TYPE, PLAN_ACTION, PLAN_PRICING_DEFAULT } from "@/contants/plan";
import planItem from "@/modules/Pricing/mixins/planItem";

export default {
  name: "PlanCompareItem",
  mixins: [plan(), planItem(), promotion()],
  props: {
    content: {},
    planNo: String,
    yearlyMode: Boolean,
    isRecommended: Boolean
  },
  data: () => {
    return {
      chargePlanActionAttribute: "",
      planFreePricing: PLAN_PRICING_DEFAULT["trial"],
      planStaterPricing: PLAN_PRICING_DEFAULT["starter"]
    };
  },
  computed: {
    isProfessionalPlan() {
      return this.planNo === PLAN_NO.BUILD && this.plan === PLAN_NO.PROFESSIONAL && !this.isDevelopmentStore;
    },
    isTrialTrial2022() {
      return this.planNo === PLAN_NO.TRIAL2022 || this.planNo === PLAN_NO.TRIAL;
    },
    isCurrentPlan() {
      return (this.isDevelopmentStore && this.planInDevelopment) || (!this.isDevelopmentStore ? this.plan === this.planNo || this.planNo === this.currentPlanUpgrade : false);
    },
    planInDevelopment() {
      return this.planNo === PLAN_NO.DEVELOPMENT_STORE;
    },
    planInStarter() {
      return this.planNo === PLAN_NO.STARTER;
    },
    planInTrial() {
      return this.planNo === PLAN_NO.TRIAL;
    },
    planInTrial2022() {
      return this.planNo === PLAN_NO.TRIAL2022;
    },
    planInTrialExpire() {
      return (this.planNo === PLAN_NO.TRIAL || this.planNo === PLAN_NO.TRIAL2022) && this.account.remainingDays <= 0;
    },
    notTrialOrDevelopment() {
      return this.planNo !== PLAN_NO.TRIAL && this.planNo !== PLAN_NO.TRIAL2022 && this.planNo !== PLAN_NO.DEVELOPMENT_STORE;
    },
    prePlanTextButton() {
      if (this.trialExpire || this.isDevelopmentStore) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.chargePlanActionAttribute = PLAN_ACTION.UPGRADE;
        if (!this.yearlyMode) return this.$t("dataNewPlan.upgradePlan.monthly");
        return this.$t("dataNewPlan.upgradePlan", { planMode: this.txtPlanMode });
      }

      if (this.isDowngrade) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.chargePlanActionAttribute = PLAN_ACTION.DOWNGRADE;
        if (this.yearlyMode) {
          return this.$t("downgrade.prePlan", { planMode: this.txtPlanMode });
        }
        return this.$t("downgrade.prePlan.monthly");
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.chargePlanActionAttribute = PLAN_ACTION.UPGRADE;
      if (!this.yearlyMode) return this.$t("dataNewPlan.upgradePlan.monthly");
      return this.$t("dataNewPlan.upgradePlan", { planMode: this.txtPlanMode });
    },
    currentPlanTextButton() {
      if (this.planInDevelopment) {
        return this.$t("dataNewPlan.currentPlan");
      }

      if (this.isProfessionalPlan) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.chargePlanActionAttribute = PLAN_ACTION.CURRENT;
        return this.$t("dataNewPlan.currentPlan");
      }

      if (this.trialExpire) {
        return this.$t("pricing.expiredPlan");
      }
      if (this.planInStarter) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.chargePlanActionAttribute = PLAN_ACTION.CURRENT;
        return this.$t("dataNewPlan.currentPlan");
      }

      if (this.yearlyMode && !this.isFreeTrial && !this.isFreeTrial2022) {
        if (!this.maybeChargeYearly) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.chargePlanActionAttribute = PLAN_ACTION.SWITCH_YEARLY;
          return this.$t("yearly.switchPlan");
        }
      }

      if (!this.yearlyMode && !this.isFreeTrial && !this.isFreeTrial2022) {
        if (!this.maybeChargeMonthly) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.chargePlanActionAttribute = PLAN_ACTION.SWITCH_MONTHLY;
          return this.$t("monthly.switchMonthlyPlan");
        }
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.chargePlanActionAttribute = PLAN_ACTION.CURRENT;
      return this.$t("dataNewPlan.currentPlan");
    },
    chargeCurrentPlan() {
      if (this.yearlyMode && !this.maybeChargeYearly) {
        return this.chargePlan(this.planNo, this.yearlyMode);
      }

      if (!this.yearlyMode && !this.maybeChargeMonthly) {
        return this.chargePlan(this.planNo, this.yearlyMode);
      }

      return "javascript:void(0)";
    },
    isDowngrade() {
      return [PLAN_NO.OPTIMIZE, PLAN_NO.ENTERPRISE, PLAN_NO.ADVANCED].includes(this.plan);
    },
    maybeChargeYearly() {
      if (!this.paymentInfo.type) return;
      return this.paymentInfo.type.toLowerCase() == PLAN_TYPE.ANNUALLY;
    },
    maybeChargeMonthly() {
      if (!this.paymentInfo.type) return;
      return this.paymentInfo.type.toLowerCase() != PLAN_TYPE.ANNUALLY;
    },
    priceOfAnnually() {
      if (this.planInDevelopment) return PLAN_PRICING_DEFAULT["development"];
      return this.checkNumberFormat(this.pricingByPlan(this.planNo, PLAN_TYPE.ANNUALLY)?.price);
    },
    basePriceOfMonthly() {
      if (this.planInStarter) return;
      if (this.planInDevelopment) return;
      return this.checkNumberFormat(this.pricingByPlan(this.planNo, PLAN_TYPE.MONTHLY)?.basePrice);
    },
    txtPlanMode() {
      return this.yearlyMode ? this.$t("dataNewPlan.planMode.yearly") : this.$t("dataNewPlan.planMode.monthly");
    },
    discountTextOfYearly() {
      const monthlyPrice = this.pricingByPlan(this.planNo, PLAN_TYPE.MONTHLY)?.basePrice;
      return (monthlyPrice - this.priceOfMonthly).toFixed(1);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
